import * as React from 'react';
import {Platform, Text, View} from 'react-native';
import {useSelector} from 'react-redux';
import {useNavigationState} from '@react-navigation/native';
import {holderProfileSelector, profileHolderUscIsBlockedSelector} from '../../../redux/selectors/profile';
import {useStyles} from '../../hooks/styles';
import {useTheme} from '../../theme';
import {DeviceSize} from '../../theme/helpers';
import {ExclamationInCircle} from '../explamationInCircle';
import {esiaUserHasNoCardsSelector} from '../../../redux/selectors/login';
import {CardStatus} from '../../../types/enums/cardStatus';
import {CardBlockedMessage} from './components/cardBlockedMessage';
import {getFocusedRouteName, SCREENS_WITHOUT_CARD_BLOCKED_BANNER} from './components/cardBlockedMessage/helpers';
import {cardBlockedNotificationHeight, useCardBlockedNotificationHeight} from './useCardBlockedNotificationHeight';

export {cardBlockedNotificationHeight} from './useCardBlockedNotificationHeight';

export const CardBlockedNotification = ({currentRouteName}: {currentRouteName?: string}) => {
  const theme = useTheme();
  const {setHeight} = useCardBlockedNotificationHeight();
  const userHasNoCards = useSelector(esiaUserHasNoCardsSelector);
  const cardHolder = useSelector(holderProfileSelector());
  const uscIsBlocked = useSelector(profileHolderUscIsBlockedSelector());
  const focusedRouteName = useNavigationState(getFocusedRouteName);
  const routeName = currentRouteName ?? focusedRouteName;
  const hideOnCurrentScreen = !!routeName && SCREENS_WITHOUT_CARD_BLOCKED_BANNER.has(routeName);
  const showNotification =
    !hideOnCurrentScreen &&
    (userHasNoCards || Boolean(uscIsBlocked) || cardHolder?.cardStatusId === CardStatus.Blocked);

  const styles = useStyles(({platformOnly, mediaOnly, align}) => {
    return {
      container: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: cardBlockedNotificationHeight,
        backgroundColor: theme.color.borderColor,
        paddingVertical: 8,
        paddingHorizontal: 16,
        ...platformOnly('web', mediaOnly(DeviceSize.desktop, {position: 'relative', zIndex: -1})),
      },
      content: {
        flexDirection: 'row',
        alignItems: 'center',
        flexShrink: 1,
        maxWidth: '100%',
      },
      message: {
        ...theme.fonts.bodySmallLight,
        color: theme.color.textColor,
        marginTop: Platform.OS !== 'android' ? align(3) : 0,
        marginLeft: 10,
      },
    };
  });

  if (!showNotification) {
    return null;
  }

  return (
    <View style={styles.container} onLayout={({nativeEvent}) => setHeight(nativeEvent.layout.height)}>
      <View style={styles.content}>
        <ExclamationInCircle backgroundColor={theme.color.primaryColor} />
        {userHasNoCards ? (
          <Text style={styles.message} testID='notification-card-blocked-title'>
            Ваше заявление принято и находится в статусе: На рассмотрении
          </Text>
        ) : (
          <CardBlockedMessage routeName={routeName} />
        )}
      </View>
    </View>
  );
};
